import './input-textarea.scss'

const InputTextarea = props => {
	const {
		value,
		placeholder = ' ',
		errors,
		id,
		label,
		register,
		change,
		min,
		max,
		name,
		maxlength
	} = props

	return (
		<div className='a-input-textarea' data-testid='test-id'>
			<label
				className={`
          a-input-label
          ${placeholder !== ' ' || (typeof value !== 'undefined' && value !== '') ? 'active ' : ''}
          ${errors && errors[name] ? 'error ' : ''}
        `}
				htmlFor={id}
			>
				{label}
			</label>
			<textarea
				id={id}
				value={value}
				onChange={e => {
					if (register && typeof register !== 'function' && register.onChange) register.onChange(e)
					if (change) change(e)
				}}
				onBlur={e => {
					if (register && typeof register !== 'function' && register.onBlur) register.onBlur(e)
				}}
				ref={register ? (typeof register === 'function' ? register : register.ref) : null}
				placeholder={placeholder}
				name={name || (register ? register.name : undefined)}
				min={min}
				max={max}
				maxLength={maxlength}
			/>
			{errors && errors[name] && (
				<span className='a-input-textarea__error'>{errors[name].message}</span>
			)}
		</div>
	)
}

export default InputTextarea
